import "../../Styles/Auth/ForgotPassword.css";
import { useContext, useState } from "react";
import SectionOneLB1 from "../../Assets/SectionOneLB1.png";
import { forgotPassword } from "../../APIService";
import { ZGAContext } from "../../ZGAContext";

const ForgotPassword = () => {
  const { showSuccessModal, setIsSubmitting } = useContext(ZGAContext);
  const [forgotPasswordInfo, setForgotPasswordInfo] = useState({
    email: "",
  });

  function handleForgotPasswordChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    setForgotPasswordInfo((prevForgotPasswordInfo) => {
      return {
        ...prevForgotPasswordInfo,
        [name]: value,
      };
    });
  }

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await forgotPassword(forgotPasswordInfo.email);
      showSuccessModal("A link has been sent to your email to reset your password.", true, "/auth/resetPassword", "Reset Password");
    } catch (error) {
      showSuccessModal(`${error.response?.data?.message || "An error occurred."}`, false, "", "");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="forgotPassword">
      <div>
        <h1>FORGOT PASSWORD</h1>
        <form onSubmit={handleForgotPassword}>
          <fieldset>
            <label>
              Email address
              <input
                type="email"
                name="email"
                required
                value={forgotPasswordInfo.email}
                onChange={handleForgotPasswordChange}
              />
            </label>
          </fieldset>
          <input type="submit" name="submit" value="Reset password" />
        </form>
      </div>
      <div>
        <img src={SectionOneLB1} alt="Background" />
        <div className="gradient"></div>
      </div>
    </div>
  );
};

export default ForgotPassword;
